import { Button ,  Modal , Row,Col, Typography } from "antd";
import React from 'react';
import RevenueIcon from './../../images/revenue.png';
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadingAction } from "../../actions/loading-actions";
import Icon from '@ant-design/icons';
import { getDateMonthYearInReadable } from "../../utils/date.utils";
import { checkActionAllowed, isPvtLtdCompany, isValid , isValidArray, isValidNumber} from "../../utils/utilities";
import './revenue.style.scss';
import { SHOW_REVENUE_IN_AGENT_CLIENT,gstRestrictedAgentPrivileges } from "../../utils/constant";
import { fetchTripSheet } from "../../actions/reports.action";
import { roundNumber, convertToCurrencyNumber } from "../../utils/math.utils";
import { getTripExpenseDetails } from "../../actions/trip-expense.actions";
import { getExpenseConfigByOperatorCode } from "../../actions/expense-config.actions";
import { tripExpenseDetailsSelector } from "../../selector/trip-expense.selector";
import { expenseConfigSelector, expenseTypesSelector } from "../../selector/expense-config.selector";


const {
    Text 
} = Typography;

const DrawLine =()=>{
    
    return(
        <div className="revenue-underline">
  
        </div>
    )
  }

const topHeaderValue = (value,label) =>{
    return(
        <Row className="revenueBlock">
            <Col>
                {label}
                <div className={label=="Net Profit"?value>0?"greenboredValue":"redboredValue":"revenueValue"}>
                ₹ {convertToCurrencyNumber(roundNumber(value))}
                </div>
            </Col>
        </Row>
    );
}

const renderAgents=(agents,showExpence,totalExpense)=>{
    let agentsDivs=[],revenue=0,totalSeatCount=0, netAmount = 0, cancelledSeatAgents = [], cancelledSeatCount = 0, totalPenalty = 0;
    if(isValidArray(agents)){
        for (let index = 0; index < agents.length; index++) {
            const record = agents[index];
            let penalityCommission = isValidNumber(record.penalityCommission)?record.penalityCommission:0;
            revenue = revenue + record.fare+(record.canellationPenality-penalityCommission)-(record.agentCommission-record.tdsAgentCommission);
                if (!gstRestrictedAgentPrivileges.includes(record.privilege) || isPvtLtdCompany()) {
                    revenue+=record.gst;
                }
                totalSeatCount = totalSeatCount + record.seatsCount;
                netAmount = netAmount+record.amount;

            if (record.seatsCount>0) {
                agentsDivs.push(<Row gutter={[16,16]}>
                    <Col span={8}>{record.agentName}</Col>
                    <Col span={8}>{record.seatsCount}</Col>
                    <Col span={8}>₹ {convertToCurrencyNumber(record.amount)}</Col>
                </Row>);
            }
            if (record.cancelledTicketsCount>0) {
                cancelledSeatCount+=record.cancelledTicketsCount;
                totalPenalty+=(record.canellationPenality-penalityCommission);
                cancelledSeatAgents.push(
                    <Row gutter={[16,16]}>
                        <Col span={8}>{record.agentName}</Col>
                        <Col span={8}>{record.cancelledTicketsCount}</Col>
                        <Col span={8}>₹ {convertToCurrencyNumber((record.canellationPenality-penalityCommission))}</Col>
                    </Row>
                )
            }
        }
        return (
            <div>
                <Row gutter={[16,16]}>
                    <Col>
                        {topHeaderValue(revenue,'Revenue')}
                    </Col>
                    {showExpence?
                    <Col>
                        {topHeaderValue(totalExpense,'Expenses')}
                    </Col>
                    :null}
                    {showExpence?
                    <Col>
                        {topHeaderValue(revenue-totalExpense,'Net Profit')}
                    </Col>
                    :null
                    }
                </Row>

                <Row>
                    <Col className="bookedValue">
                        Confirmed Seats
                    </Col>
                </Row>
                <Row gutter={[16,16]}>
                    <Col>
                    <Text strong>Revenue</Text>
                    <DrawLine />
                  </Col>
                </Row>
                <div>
                {agentsDivs}
                </div>
                <Row gutter={[16,16]}>
                    <Col span={8}></Col>
                    <Col span={8} className="bookedValue">
                        {totalSeatCount}
                    </Col>
                    <Col span={8} className="bookedValue">
                        ₹ {convertToCurrencyNumber(roundNumber(netAmount))}
                    </Col>
                </Row>
                {cancelledSeatCount>0&&
                    <div>
                        <Row>
                            <Col className="bookedValue">
                                Cancelled Seats
                            </Col>
                        </Row>
                        <div>
                            {cancelledSeatAgents}
                        </div>
                        <Row gutter={[16,16]}>
                            <Col span={8}></Col>
                            <Col span={8} className="bookedValue">
                                {cancelledSeatCount}
                            </Col>
                            <Col span={8} className="bookedValue">
                                ₹ {convertToCurrencyNumber(roundNumber(totalPenalty))}
                            </Col>
                        </Row>
                    </div>
                }
            </div>
        )
        
    }else{
        return null
    }
}

// Map expense type keys to form field names
const getFormFieldName = (expenseKey) => {
    const fieldMap = {
        'bata': 'bata',
        'toll': 'toll',
        'pooja': 'pooja',
        'bus_expenses': 'bus_expense',
        'parking': 'parking_expense',
        'driver': 'driver_expense',
        'attender': 'attender_expense',
        'grease_and_air': 'grease_and_air_expense',
        'misc': 'misc'
    };
    return fieldMap[expenseKey] || expenseKey;
};

const renderExpenseDetails = (tripExpenseDetails, expenseTypes, expenseConfig) =>{
    const renderEachExpense = (expense,expenseName) =>{
        if(expense>0){
            return (
                <Row justify="space-between" >
                    <Col span={12}>
                    {
                        expenseName == "Total" ? <Text strong>{expenseName}</Text> : <Text>{expenseName}</Text>
                    }
                    </Col>
                    <Col span={12}>
                    {
                        expenseName == "Total" ? <Text strong>₹ {expense}</Text> : <Text>₹ {expense}</Text>     
                    }
                    </Col>
                </Row>
            );
        }else{
            return null;
        }
    }

    if (!expenseTypes || !expenseConfig) {
        return null;
    }

    // Get expense type keys and filter by config
    const expenseTypeKeys = Object.keys(expenseTypes);
    const visibleExpenseTypes = expenseTypeKeys.filter(key => {
        return expenseConfig[key] === 1;
    });

    // Sort by order property
    const sortedExpenseTypes = visibleExpenseTypes.sort((a, b) => {
        const orderA = expenseTypes[a]?.order || 0;
        const orderB = expenseTypes[b]?.order || 0;
        return orderA - orderB;
    });

    let total = 0;
    const expenseRows = [];

    // Render each expense type
    sortedExpenseTypes.forEach(expenseKey => {
        const expenseType = expenseTypes[expenseKey];
        const fieldName = getFormFieldName(expenseKey);
        const expenseValue = tripExpenseDetails[fieldName];
        
        if(isValid(expenseValue) && expenseValue > 0){
            total += expenseValue;
            expenseRows.push(
                renderEachExpense(expenseValue, expenseType.label)
            );
        }
    });

    return (
        <div>
            {expenseRows}
            {renderEachExpense(total,"Total")}
        </div>
    )
}


export const RevenueDetails = (props) => {

    const {
        tripId,
        fetchExpenses = true
    } = props;

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [revenueDetails, setRevenueDetails] = useState(null);
    const tripExpense = useSelector(tripExpenseDetailsSelector);
    const expenseConfig = useSelector(expenseConfigSelector);
    const expenseTypes = useSelector(expenseTypesSelector);

    const dispatch = useDispatch();

    // Fetch expense config if not present
    useEffect(() => {
        if (fetchExpenses&&!expenseConfig && !expenseTypes && global.operatorCode) {
            dispatch(getExpenseConfigByOperatorCode(global.operatorCode));
        }
    }, [fetchExpenses, expenseConfig, expenseTypes, dispatch]);

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const setLoading = (value)=>{
        dispatch(loadingAction(value));
    }

    const onSuccess=(data)=>{
        setRevenueDetails(data);
        setLoading(false);
    }

    const onFailure=()=>{
        setLoading(false);
    }

    if(checkActionAllowed(SHOW_REVENUE_IN_AGENT_CLIENT)){

        let totalExpense = 0;
        let showExpence = isValidArray(tripExpense)&&isValid(tripExpense.id)?true:false;
        if(showExpence && expenseTypes && expenseConfig){
            // Calculate total expense based on enabled expense types
            const expenseTypeKeys = Object.keys(expenseTypes);
            const visibleExpenseTypes = expenseTypeKeys.filter(key => {
                return expenseConfig[key] === 1;
            });

            visibleExpenseTypes.forEach(expenseKey => {
                const fieldName = getFormFieldName(expenseKey);
                if(isValid(tripExpense[fieldName])){
                    totalExpense += tripExpense[fieldName];
                }
            });
        }

        
        return (
            <div>
                    <Button 
                    onClick={async()=>{
                        setLoading(true);
                        if(isValid(tripId)){
                            await fetchTripSheet(tripId,onSuccess,onFailure);
                            dispatch(getTripExpenseDetails(tripId));
                        }
                        showModal(true);
                    }} 
                    ghost 
                    className="open-select-seat-btn">
                        <Icon component={() => (<img src={RevenueIcon} style={{width:'23px',padding:'1px'}} />)} />
                    </Button>
                <Modal 
                    centered={true}
                    visible={isModalVisible} 
                    onOk={handleOk} 
                    onCancel={handleCancel}
                    okText="Update"
                    footer={null}
                    width={600}
                    >
                        {isValidArray(revenueDetails)?
                            <div>
                                <Row gutter={[16,16]}>
                                    <Col>
                                        <div className="revenueTripDate">
                                            {getDateMonthYearInReadable(revenueDetails.tripDetails.start_date)}
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className="revenueTripDescription">
                                            {revenueDetails.tripDetails.description}
                                        </div>
                                    </Col>
                                </Row>
                                {renderAgents(revenueDetails.bookingInfo,showExpence,totalExpense)}
                            </div>
                        :
                        null
                        }
                        {showExpence?
                            <div>
                               <Row gutter={[16,16]}>
                                    <Col>
                                        <Text strong>Expenses</Text>
                                        <DrawLine />
                                    </Col>
                                </Row>
                                {renderExpenseDetails(tripExpense, expenseTypes, expenseConfig)}
                            </div>
                            :null
                        }
                </Modal>
            </div>
          );
    }else{
        return null;
    }
};
